<p-dialog header="{{contactHeader}}" [(visible)]="display" [modal]="true" [style]="{ width: '60vw' }" (onHide)="close()">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-jc-between w-100">
            <h5 class="p-mb-0">{{contactHeader}}</h5>
            <div class="p-d-flex">
                <button *ngIf="isView" pButton (click)="enableContactEdit()" icon="pi pi-pencil" class="p-button-text p-button-rounded"></button>
            </div>
        </div>
    </ng-template>

    <form [formGroup]="contactForm">
        <div class="header p-d-flex p-jc-between">
            <h5 class="p-mt-2 p-mb-0">Contact information</h5>
            <p-dropdown [options]="contactTypesNew" formControlName="selectedContactType"
                        placeholder="Select Contact Type ..." optionLabel="name" appendTo="body"
                        (onHide)="changeContactType()" required>
                <ng-template pTemplate="item" let-type>
                    <div class="p-d-flex">
                        <span class="pi pi-plus p-mr-2" *ngIf="type.name == 'New Contact Type'"></span>
                        <div>{{type.name}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="card" *ngIf="!isView">
            <div class="p-grid">
                <div class="p-col-1">
                    <label>Title</label>
                    <p-dropdown [options]="salutations" optionValue="" formControlName="salutation"
                    optionLabel="name" appendTo="body" placeholder="..."></p-dropdown>
                </div>
                <div class="p-col-3">
                    <label>First Name <span style="color: red;">*</span></label>
                    <input formControlName="firstName" pInputText type="text" id="firstName" name="firstName" pattern="^[^:]*$" required />
                </div>
                <div class="p-col-1">
                    <label>M.I</label>
                    <input formControlName="middleName" pInputText type="text" name="middleName" pattern="^[^:]*$"/>
                </div>
                <div class="p-col-3">
                    <label>Last Name </label>
                    <input formControlName="lastName" pInputText type="text" pattern="^[^:]*$" id="lastName" name="lastName" />
                </div>
                <div class="p-col-4">
                    <label>Company Name </label>
                    <!-- <input pInputText type="text" pattern="^[^:]*$" id="compaynyName" name="compaynyName" /> -->
                    <input formControlName="companyName" pInputText type="text" pattern="^[^:]*$" id="companyName" name="companyName" />
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-4">
                    <label>Email Address</label>
                    <input formControlName="email" type="email" name="email" pInputText
                    pattern="[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,4}$" email>
                </div>
                <div class="p-col-2">
                    <label>Sources </label>
                    <p-dropdown [options]="sources" formControlName="selectedContactSource" placeholder="Select Source"
                        optionLabel="name" appendTo="body">
                        <ng-template pTemplate="item" let-type>
                            <div class="p-d-flex">
                                <div>{{type.name}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <div class="p-col-2">
                            <label for="country">Country<span style="color: red;">*</span></label>
                            <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                optionLabel="CountryName"
                                formControlName="code" (onChange)="onCountrySelect($event)"
                                class="inline" appendTo="body">
                            </p-dropdown>
                </div>
                <!-- [ngClass]="{'p-col-12': selectedContact?.phone}" -->
                <div class="p-col-4" >
                        <label for="phone">Phone<span style="color: red;">*</span></label>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">+{{contactForm?.value.code?.PhoneCode}}</span>
                        <p-inputMask #phoneInput *ngIf="phoneNumberFormat && !maskingDisabled"
                            formControlName="phone" [mask]="phoneNumberFormat" slotChar="_" [autoClear]="false"
                            class="w-100"></p-inputMask>
                            <input *ngIf="!(phoneNumberFormat && !maskingDisabled)" type="text" style="width: 250px; height: 30px;" pInputText
                            formControlName="phone">
                    </div>
                </div>
                
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Tags
                        <span class="btnBars" (click)="addTag()"><i class="pi pi-plus"></i></span>
                    </label>
                    <ng-container *ngFor="let s of tags; let i = index">
                        <p-tag class="p-ml-2" [style]="{'background-color': s.color}">
                            <div style="display: flex;padding: 2px;" (click)="removeTag(i)">
                                <div>{{s.name}}</div>
                                <div class="crossIconAlignment"><i style="font-size: 8px;" class="pi pi-times"></i></div>
                            </div>
                        </p-tag>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="card" *ngIf="isView">
            <div class="p-grid">
                <ng-container *ngIf="contactForm.controls['salutation'].value !== '' && contactForm.controls['salutation'].value !== null">
                    <div class="p-col-2 p-pt-0 p-pb-0">
                        <p><strong>Title</strong></p>
                    </div>
                    <div class="p-col-4 p-pt-0 p-pb-0">
                        <p>{{ contactForm.controls['salutation']?.value?.name }}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="contactForm.controls['firstName'].value !== '' && contactForm.controls['firstName'].value !== null">
                    <div class="p-col-2 p-pt-0 p-pb-0">
                        <p><strong>First Name</strong></p>
                    </div>
                    <div class="p-col-4 p-pt-0 p-pb-0">
                        <p>{{ contactForm.controls['firstName'].value }}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="contactForm.controls['middleName'].value !== '' && contactForm.controls['middleName'].value !== null">
                    <div class="p-col-2 p-pt-0 p-pb-0">
                        <p><strong>Middle Name</strong></p>
                    </div>
                    <div class="p-col-4 p-pt-0 p-pb-0">
                        <p>{{ contactForm.controls['middleName'].value }}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="contactForm.controls['lastName'].value !== '' && contactForm.controls['lastName'].value !== null">
                    <div class="p-col-2 p-pt-0 p-pb-0">
                        <p><strong>Last Name</strong></p>
                    </div>
                    <div class="p-col-4 p-pt-0 p-pb-0">
                        <p>{{ contactForm.controls['lastName'].value }}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="contactForm.controls['companyName'].value !== '' && contactForm.controls['companyName'].value !== null">
                    <div class="p-col-2 p-pt-0 p-pb-0">
                        <p><strong>Company Name</strong></p>
                    </div>
                    <div class="p-col-4 p-pt-0 p-pb-0">
                        <p>{{ contactForm.controls['companyName'].value }}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="contactForm.controls['email'].value !== '' && contactForm.controls['email'].value !== null">
                    <div class="p-col-2 p-pt-0 p-pb-0">
                        <p><strong>Email Address</strong></p>
                    </div>
                    <div class="p-col-4 p-pt-0 p-pb-0">
                        <p>{{ contactForm.controls['email'].value }}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="contactForm.controls['phone'].value !== '' && contactForm.controls['phone'].value !== null">
                    <div class="p-col-2 p-pt-0 p-pb-0">
                        <p><strong>Phone</strong></p>
                    </div>
                    <div class="p-col-4 p-pt-0 p-pb-0">
                        <p>
                            <span *ngIf="contactForm.controls['code'].value?.PhoneCode !== '' && contactForm.controls['code'].value?.PhoneCode !== null">
                                (+{{ contactForm.controls['code'].value?.PhoneCode}})
                            </span>
                            {{ contactForm.controls['phone'].value }}
                        </p>
                    </div>
                </ng-container>
                <ng-container>
                    <div class="p-col-2 p-pt-0 p-pb-0">
                        <p><strong>Tags</strong></p>
                    </div>
                    <div *ngFor="let s of tags; let i = index">
                        <p-tag styleClass="p-ml-1" [value]="s?.name" [style]="{'background-color': s.color}"></p-tag>
                    </div>
                </ng-container>
              
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <button type="button" pButton (click)="close()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" *ngIf="!selectedContact" pButton [disabled]="contactForm.invalid" label="Save" (click)="saveNewContact()"></button>
        <button type="button" *ngIf="selectedContact && selectedContact?.mode === 'edit'"  pButton [disabled]="contactForm.invalid" label="Update & View" (click)="updateContact('view')"></button>
        <button type="button" *ngIf="selectedContact && selectedContact?.mode === 'edit'"  pButton [disabled]="contactForm.invalid" label="Update" (click)="updateContact()"></button>
        <button type="button" *ngIf="selectedContact && selectedContact?.mode === 'copy'" pButton 
        [disabled]="contactForm.invalid || (checkNumber()==false)" label="Save" (click)="saveNewContact()"></button>
    </ng-template>

</p-dialog>

<p-dialog header="New Contact Type" [(visible)]="displayNewContactType" [style]="{ width: '50vw' }">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-text-right">
                <p-inputSwitch [(ngModel)]="tempContactType.isActive"></p-inputSwitch>
            </div>
            <div class="p-col-6">
                <label>Name <span style="color: red;">*</span></label>
                <input type="text" [(ngModel)]="tempContactType.name" pInputText required>
            </div>
            <div class="p-col-6">
                <label>Description</label>
                <input type="text" [(ngModel)]="tempContactType.description" pInputText >
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" pButton (click)="displayNewContactType=false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton label="Save" [disabled]="!tempContactType.name" (click)="saveContactType()"></button>
    </ng-template>
</p-dialog>

<!-- tag -->
<ng-container *ngIf="displayAddTag">
    <app-assign-tag-dialog
        [showDialog]="displayAddTag"
        [selectedTags]="selectedValues"
        [tagList]="tagList"
        (assignedTag)="assignSelectedTags($event)"
        (addNewTag)="displayCreateTag = true"
        (closed)="displayAddTag = false">
    </app-assign-tag-dialog>
</ng-container>

<!-- Show add new tag dialog-->
<ng-container *ngIf="displayCreateTag">
    <app-add-tag-dialog
        [showDialog]="displayCreateTag"
        (clickSubmit)="createTag($event)"
        (closed)="displayCreateTag = false">
    </app-add-tag-dialog>
</ng-container>